module.exports = __webpack_public_path__ + "static/media/room-cover.52079abf.jpg";